
// make sure it runs only one time (!)
import {ItemIcon, ItemIconDictionary} from "./@type";
import {ItemIconConfig} from "./config";

const generateItemIconDictionary = () : ItemIconDictionary => {

    const result: ItemIconDictionary = {}

    ItemIconConfig.forEach((itemIcon:ItemIcon) => {

        result[itemIcon.name] = {
            name        : itemIcon.name,
            className   : itemIcon.className,
            keyword     : itemIcon.keyword || itemIcon.name
        }
    })

    return result
}

export const ItemIconDict : ItemIconDictionary = generateItemIconDictionary()

